import { combineLatest, of, Subject } from 'rxjs';
import { map, shareReplay, switchMap, takeUntil } from 'rxjs/operators';

import { Injectable, OnDestroy } from '@angular/core';

import { SnIntegrationsAPI } from '@lib/api/services/integrations.service';
import { SnCurrentUser } from '@lib/auth/services/current-user.service';

type AxonConnectMetadata = {
  features?: {
    respond?: boolean;
    alpr?: boolean;
  };
  regionCode?: string;
  agencyId?: string;
};

@Injectable({
  providedIn: 'root',
})
export class AxonConnectIntegrationService implements OnDestroy {
  private _destroyed$ = new Subject<boolean>();

  constructor(
    private readonly _integrationService: SnIntegrationsAPI,
    private readonly _currentUserService: SnCurrentUser,
  ) {}

  integrationMetadata$ = this._integrationService.checkIntegrations().pipe(
    switchMap(() =>
      of(this._integrationService.getIntegrationByCode<AxonConnectMetadata>('axonconnect')),
    ),
    map((integration) => integration?.meta),
    shareReplay(1),
    takeUntil(this._destroyed$),
  );

  authToken$ = this._currentUserService.getSettings().pipe(
    map((settings) => settings?.authTokens?.axonconnect),
    takeUntil(this._destroyed$),
  );

  authTokenAndMetadata$ = combineLatest([this.authToken$, this.integrationMetadata$]);

  ngOnDestroy(): void {
    this._destroyed$.next(true);
  }
}
